<template>
  <aside v-if="visible && currentDetailNode" class="fishbone-detail-panel" :class="{ 'fishbone-detail-panel--collapsed': collapsed }">
    <button
      type="button"
      class="fishbone-detail-panel__toggle"
      :title="collapsed ? $LANG('', '展开') : $LANG('0332', '收起')"
      @click="$emit('toggle')">
      <i :class="collapsed ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
    </button>
    <div v-show="!collapsed" class="fishbone-detail-panel__inner">
      <div class="fishbone-detail-panel__header">
        <span class="fishbone-detail-panel__title">{{ detailTitle }}</span>
        <button type="button" class="fishbone-detail-panel__close" :title="$LANG('1945', '关闭')" @click="$emit('close')">
          <i class="el-icon-close"></i>
        </button>
      </div>
      <div class="fishbone-detail-panel__body">
        <div v-if="currentDetailNode && currentDetailNode.type === 'root'" class="root-detail root-detail--order">
          <div class="root-detail-order-form-v2">
            <div class="root-detail-order-row-v2">
              <div class="root-detail__item">
                <span>生产订单</span>
                <strong class="root-detail__value--ordno">{{ displayText(currentProjectRow.ORDNO || currentProjectRow.IDNO) }}</strong>
              </div>
              <div class="root-detail__item">
                <span>客户代码</span>
                <strong>{{ displayText(currentProjectRow.CLNT_IDNO) }}</strong>
              </div>
            </div>
            <div class="root-detail-order-row-v2">
              <div class="root-detail__item">
                <span>交货日期</span>
                <strong>{{ displayText(currentProjectRow.SHPDTTM || currentProjectRow.FINDTTM) }}</strong>
              </div>
              <div class="root-detail__item">
                <span>负责人</span>
                <strong>{{ displayText(currentProjectRow.EMPNM2 || currentProjectRow.EMPNM) }}</strong>
              </div>
            </div>
            <div class="root-detail__item root-detail__item--wide root-detail__item--full">
              <span>产品名称</span>
              <strong>{{ displayText(currentProjectRow.MATNM) }}</strong>
            </div>
            <div class="root-detail-order-row-v2">
              <div class="root-detail__item">
                <span>订单数量</span>
                <strong>{{ displayText(currentProjectRow.QTY) }}</strong>
              </div>
              <div class="root-detail__item">
                <span>生产数量</span>
                <strong>{{ displayText(currentProjectRow.PCQTY) }}</strong>
              </div>
            </div>
            <div class="root-detail-order-row-v2">
              <div class="root-detail__item">
                <span>入库数量</span>
                <strong>{{ displayText(currentProjectRow.INQTY) }}</strong>
              </div>
              <div class="root-detail__item">
                <span>状态</span>
                <strong><span class="task-detail__status" :style="{ background: currentDetailStatusInfo.color }">{{ currentDetailStatusInfo.text }}</span></strong>
              </div>
            </div>
          </div>
          <div class="root-detail__scroll">
            <div class="detail-section-title">当前订单附件明细</div>
            <div class="root-detail__attachment-scroll">
              <el-timeline v-if="currentRootAttachments.length" class="detail-timeline">
                <el-timeline-item v-for="(item, index) in currentRootAttachments" :key="index" placement="top">
                  <div class="timeline-card">
                    <div class="attachment-detail-row">
                      <div class="attachment-detail-row__meta-line">
                        <span class="attachment-detail-row__meta">{{ displayText(item.ADDDTTM) }}</span>
                        <span class="attachment-detail-row__meta">{{ displayText(item.ADDUSER) }}</span>
                      </div>
                      <el-link class="attachment-detail-row__link" :underline="false" @click="$emit('open-attachment', item)">{{ displayText(item.FILENM) }}</el-link>
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
              <div v-else class="detail-empty">暂无附件</div>
            </div>
          </div>
        </div>
        <div v-else-if="currentDetailNode" class="task-detail">
          <div class="task-detail__form-grid">
            <div class="task-detail__field"><span class="task-detail__label">负责人</span><strong class="task-detail__value">{{ displayText(currentTaskRow.EMPNM2 || currentTaskRow.EMPNM) }}</strong></div>
            <div class="task-detail__field"><span class="task-detail__label">截止时间</span><strong class="task-detail__value">{{ displayText(currentTaskRow.FINDTTM) }}</strong></div>
            <div class="task-detail__field"><span class="task-detail__label">进度</span><strong class="task-detail__value">{{ displayText(currentTaskRow.PCT) }}%</strong></div>
            <div class="task-detail__field"><span class="task-detail__label">状态</span><strong class="task-detail__value"><span class="task-detail__status" :style="{ background: currentDetailStatusInfo.color }">{{ currentDetailStatusInfo.text }}</span></strong></div>
          </div>
          <div class="task-detail__scroll">
            <div class="detail-section-title">跟进详情</div>
            <el-timeline v-if="currentLogList.length" class="detail-timeline">
              <el-timeline-item v-for="(item, index) in currentLogList" :key="index" :color="item.COLOR" placement="top">
                <div class="timeline-card">
                  <div class="timeline-card__meta">
                    <span class="timeline-card__meta-info">
                      <span>{{ item.DTTM }}</span>
                      <span>{{ item.ADDUSER }}</span>
                    </span>
                    <span v-if="!isReadonlyMode" class="timeline-card__actions">
                      <el-button class="timeline-card__icon-btn" type="text" size="small" icon="el-icon-edit" :title="$LANG('0016', '编辑')" @click="$emit('log-edit', item)"></el-button>
                      <el-button class="timeline-card__icon-btn timeline-card__delete" type="text" size="small" icon="el-icon-delete" :title="$LANG('0131', '删除')" @click="$emit('log-delete', item, index)"></el-button>
                    </span>
                  </div>
                  <div class="timeline-line"><strong class="timeline-line__label">跟进内容：</strong>{{ displayText(item.LOGRMK) }}</div>
                </div>
              </el-timeline-item>
            </el-timeline>
            <div v-else class="detail-empty">暂无跟进记录</div>
            <div class="detail-section-title">节点附件</div>
            <div v-if="currentTaskAttachments.length" class="attachment-detail-list">
              <div v-for="(item, index) in currentTaskAttachments" :key="index" class="attachment-item">
                <div class="attachment-detail-row">
                  <div class="attachment-detail-row__meta-line">
                    <span class="attachment-detail-row__meta">{{ displayText(item.ADDDTTM) }}</span>
                    <span class="attachment-detail-row__meta">{{ displayText(item.ADDUSER) }}</span>
                  </div>
                  <el-link class="attachment-detail-row__link" :underline="false" @click="$emit('open-attachment', item)">{{ displayText(item.FILENM) }}</el-link>
                </div>
              </div>
            </div>
            <div v-else class="detail-empty">暂无附件</div>
          </div>
        </div>
      </div>
      <div class="fishbone-detail-panel__footer">
        <template v-if="currentDetailNode && currentDetailNode.type !== 'root'">
          <el-button v-if="currentDetailNode.refidty" size="mini" type="info" plain :disabled="currentActionState.sourceReadonly" @click="$emit('current-ref-document')">来源单据</el-button>
          <template v-if="!isReadonlyMode">
            <el-button size="mini" type="primary" plain :disabled="currentActionState.settingDisabled" @click="$emit('follow-add')">{{ currentTaskRow.ORDER_PROCESS_EXISTS ? '跟进' : '设置' }}</el-button>
          </template>
        </template>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ProcessDetailPanel',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    detailTitle: {
      type: String,
      default: ''
    },
    currentDetailNode: {
      type: Object,
      default: function () { return null }
    },
    currentProjectRow: {
      type: Object,
      default: function () { return {} }
    },
    currentTaskRow: {
      type: Object,
      default: function () { return {} }
    },
    currentRootAttachments: {
      type: Array,
      default: function () { return [] }
    },
    currentTaskAttachments: {
      type: Array,
      default: function () { return [] }
    },
    currentLogList: {
      type: Array,
      default: function () { return [] }
    },
    currentActionState: {
      type: Object,
      default: function () { return {} }
    },
    currentDetailStatusInfo: {
      type: Object,
      default: function () { return {} }
    },
    isReadonlyMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    }
  }
}
</script>

<style scoped>
.fishbone-detail-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  width: 430px;
  height: 100%;
  border-left: 1px solid #dcdfe6;
  background: #f7f9fc;
  box-shadow: -6px 0 18px rgba(31, 45, 61, .08);
  transition: width .18s ease;
}
.fishbone-detail-panel--collapsed {
  width: 0;
  border-left: 0;
  background: transparent;
  box-shadow: none;
}
.fishbone-detail-panel__toggle {
  position: absolute;
  top: 50%;
  left: -30px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 42px;
  padding: 0;
  border: 1px solid #dcdfe6;
  border-right: 0;
  border-radius: 4px 0 0 4px;
  background: #fff;
  color: #409eff;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  transform: translateY(-50%);
}
.fishbone-detail-panel__toggle:hover {
  color: #1f7ae0;
  background: #ecf5ff;
}
.fishbone-detail-panel__inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
}
.fishbone-detail-panel__header {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 0 14px 0 16px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
}
.fishbone-detail-panel__title {
  flex: 1;
  min-width: 0;
  color: #1f2f3d;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fishbone-detail-panel__close {
  flex: none;
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
}
.fishbone-detail-panel__close:hover {
  color: #409eff;
  border-color: #409eff;
}
.fishbone-detail-panel .fishbone-detail-dialog__status {
  align-self: flex-start;
  margin: 12px 16px 0;
}
.fishbone-detail-panel__body {
  flex: 1;
  min-height: 0;
  padding: 10px;
  overflow: hidden;
}
.fishbone-detail-panel__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 48px;
  padding: 8px 14px;
  border-top: 1px solid #ebeef5;
  background: #fff;
}
.fishbone-detail-panel__footer .el-button + .el-button {
  margin-left: 0;
}
.root-detail {
  color: #303133;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.root-detail__meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.root-detail__meta > div {
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
}
.root-detail__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 10px;
}
.root-detail__grid--order {
  margin-top: 0;
}
.root-detail__order-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}
.root-detail__order-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 10px;
}
.root-detail__order-row--single {
  grid-template-columns: minmax(0, 1fr);
}
.root-detail-order-form-v2 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-width: 0;
}
.root-detail-order-row-v2 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 10px;
  width: 100%;
  min-width: 0;
}
.root-detail__item {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
}
.task-detail__form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.task-detail__field {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
}
.root-detail__item--wide,
.task-detail__field--wide {
  grid-column: 1 / -1;
}
.root-detail__item--full {
  width: 100%;
  box-sizing: border-box;
}
.root-detail span {
  display: block;
  margin-bottom: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 16px;
}
.root-detail strong {
  display: block;
  color: #303133;
  font-size: 13px;
  line-height: 20px;
  overflow: visible;
  overflow-wrap: break-word;
  text-overflow: clip;
  word-break: normal;
  white-space: normal;
}
.root-detail__meta strong {
  color: #1f7ae0;
  font-size: 18px;
  line-height: 24px;
}
.root-detail--order strong {
  font-size: 18px;
  line-height: 24px;
}
.root-detail--order .root-detail__value--ordno {
  font-size: 20px;
  line-height: 26px;
  overflow-wrap: normal;
  word-break: normal;
}
.root-detail__scroll {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  margin-top: 14px;
}
.root-detail__attachment-scroll {
  flex: 1;
  min-height: 0;
  padding-right: 8px;
  overflow-y: auto;
  scrollbar-color: #c0c4cc transparent;
  scrollbar-width: thin;
}
.root-detail__attachment-scroll::-webkit-scrollbar {
  width: 2px;
}
.root-detail__attachment-scroll::-webkit-scrollbar-track {
  border-radius: 2px;
  background: transparent;
}
.root-detail__attachment-scroll::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: #c0c4cc;
}
.root-detail__attachment-scroll::-webkit-scrollbar-thumb:hover {
  background: #909399;
}
.task-detail {
  color: #303133;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.task-detail__scroll {
  flex: 1;
  min-height: 0;
  margin-top: 14px;
  padding-right: 8px;
  overflow-y: auto;
  scrollbar-color: #c0c4cc transparent;
  scrollbar-width: thin;
}
.task-detail__scroll::-webkit-scrollbar {
  width: 2px;
}
.task-detail__scroll::-webkit-scrollbar-track {
  border-radius: 2px;
  background: transparent;
}
.task-detail__scroll::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: #c0c4cc;
}
.task-detail__scroll::-webkit-scrollbar-thumb:hover {
  background: #909399;
}
.task-detail__field {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 8px 10px;
  border: 0;
  border-radius: 11px;
  background: #f5f5f7;
}
.task-detail__label {
  flex: none;
  min-width: 72px;
  margin-right: 8px;
  color: #6e6e73;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
}
.task-detail__value {
  flex: 1;
  min-width: 0;
  color: #1d1d1f;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  overflow: visible;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal;
}
.task-detail__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  height: 22px;
  min-height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  vertical-align: middle;
}
.detail-section-title {
  margin-top: 14px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}
.task-detail__scroll > .detail-section-title:first-child {
  margin-top: 0;
}
.root-detail__scroll > .detail-section-title:first-child {
  margin-top: 0;
}
.attachment-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.attachment-list--inline {
  margin-top: 6px;
}
.attachment-detail-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.attachment-item {
  min-width: 80px;
  max-width: 180px;
  padding: 4px 8px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.attachment-detail-list .attachment-item {
  max-width: none;
  width: 100%;
  white-space: normal;
}
.attachment-detail-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}
.attachment-detail-row__meta-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 22px;
  width: 100%;
  min-width: 0;
}
.attachment-detail-row__meta {
  color: #606266;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}
.attachment-detail-row__link {
  color: #0066cc !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.attachment-detail-row__link .el-link--inner {
  color: #0066cc !important;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.detail-timeline {
  margin-top: 6px;
  padding-left: 2px;
}
.detail-timeline .el-timeline-item {
  padding-bottom: 10px;
}
.detail-timeline .el-timeline-item__node--normal {
  left: 0;
}
.detail-timeline .el-timeline-item__tail {
  left: 5px;
}
.timeline-card {
  padding: 6px 10px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #f7f8f9;
}
.timeline-card__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 3px;
  color: #303133;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
}
.timeline-card__meta-info {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 12px;
  min-width: 0;
  flex: 1;
  overflow: hidden;
}
.timeline-card__meta-info span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.timeline-card__actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex: none;
  margin-left: auto;
  font-weight: 400;
  line-height: 16px;
}
.timeline-card__actions .el-button--small {
  padding: 0;
}
.timeline-card__icon-btn {
  width: 24px;
  height: 24px;
  padding: 0 !important;
  border-radius: 50%;
  color: #0066cc;
  font-size: 16px;
  line-height: 24px;
}
.timeline-card__icon-btn:hover,
.timeline-card__icon-btn:focus {
  background: rgba(0, 102, 204, .08);
}
.timeline-card__delete {
  color: #f56c6c;
}
.timeline-card__delete:hover,
.timeline-card__delete:focus {
  color: #f78989;
}
.timeline-line {
  margin-bottom: 3px;
  font-size: 12px;
  color: #303133;
  line-height: 16px;
}
.timeline-line__label {
  font-weight: 700;
}
.timeline-line:last-child {
  margin-bottom: 0;
}
.detail-empty {
  padding: 16px 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  color: #909399;
  font-size: 12px;
  text-align: center;
}
</style>
